/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState,useRef } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { useForm } from "react-hook-form";
import { Toast } from 'primereact/toast';
import { useDispatch } from 'react-redux';


import { AuthServ } from "../services/api/AuthServ";
import { setAuth } from '../slices/authSlice';



const Login = ({ open, closeLogin }) => {
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [visible, setVisible] = useState(open);
    const { register, handleSubmit,reset } = useForm();
    const onSubmit = (data) => {
        console.log(data);
        login(data)
    };

    useEffect(() => {
        setVisible(open)
    })

    const closeDialog = () => {
        setVisible(false)
        closeLogin()
    }

    const login = async (payload) => {
        try {
            let res = await AuthServ.login(payload);
            console.log(res)
            localStorage.setItem("token", res.token)
            dispatch(setAuth(res.user))
            reset()
            closeDialog()
        } catch (error) {
            console.log(error)
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.message })
        } finally {

        }
    }



    return (
        <div className="card flex justify-content-center">
            <Toast ref={toast} />
            <Dialog
                visible={visible}
                modal
                onHide={() => closeDialog()}
                content={({ hide }) => (
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <div className="flex flex-column px-8 py-5 gap-4" style={{ borderRadius: '12px', backgroundImage: 'radial-gradient(circle at left top, var(--primary-400), var(--primary-700))' }}>
                            <div className="inline-flex flex-column gap-2">
                                <label htmlFor="email" className="text-primary-50 font-semibold">
                                    Email
                                </label>
                                <InputText id="email" name="email" label="Email"  {...register('email', { required: true })} className="bg-white-alpha-20 border-none p-3 text-primary-50"></InputText>
                            </div>
                            <div className="inline-flex flex-column gap-2">
                                <label htmlFor="password" className="text-primary-50 font-semibold">
                                    Password
                                </label>
                                <InputText id="password" name="password" label="Password" {...register('password', { required: true })} className="bg-white-alpha-20 border-none p-3 text-primary-50" type="password"></InputText>
                            </div>
                            <div className="flex align-items-center gap-2">
                                <Button label="Log-In" type="submit" text className="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"></Button>
                                <Button label="Cancel" onClick={(e) => {e.preventDefault();closeDialog()}} text className="p-3 w-full text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"></Button>
                            </div>
                        </div>
                    </form>
                )}
            ></Dialog>
        </div>
    )
}


export default Login